import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import Select from "react-select";

import classNames from "classnames";

import { LFPFormProps } from "../types/lookingforplayers";

import Loading from "../../../../../components/Loading";
import { displayFormAlert } from "../../../../../lib/utils";

const LFPForm = ({
    sending,
    methods,
    handleSubmit,
    setShow,
    looking,
    positions,
    ageLevels,
}: LFPFormProps): React.JSX.Element => {
    return (
        <Form
            id="clubhouseTeamLFPForm"
            onSubmit={methods.handleSubmit(handleSubmit)}
            data-testid="clubhouseTeamLFPForm"
        >
            <h2>Submit New Player Request</h2>
            <Row>
                <Col>
                    <Form.Group
                        controlId="description"
                        data-testid="description"
                    >
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={6}
                            {...methods.register("description")}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={6}>
                    <Form.Group controlId="positions" data-testid="positions">
                        <Form.Label id="positions">Position(s)</Form.Label>
                        <Controller
                            name="positions"
                            control={methods.control}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    aria-labelledby="positions"
                                    isMulti
                                    isSearchable={false}
                                    options={positions.map(p => {
                                        return {
                                            value: parseInt(p.id.toString()),
                                            label: p.position,
                                        };
                                    })}
                                />
                            )}
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group controlId="ageLevels" data-testid="ageLevels">
                        <Form.Label id="ageLevels">Age Level(s)</Form.Label>
                        <Controller
                            name="ageLevels"
                            control={methods.control}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    aria-labelledby="ageLevels"
                                    isMulti
                                    isSearchable={false}
                                    options={ageLevels.map(a => {
                                        return {
                                            value: parseInt(a.id.toString()),
                                            label: a.ageLevel,
                                        };
                                    })}
                                />
                            )}
                        />
                        {methods.formState.errors.ageLevels &&
                            displayFormAlert({
                                level: "danger",
                                text: methods.formState.errors.ageLevels
                                    .message as string,
                                settings: "mb-0",
                            })}
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group controlId="contactName">
                        <Form.Label>Contact Name</Form.Label>
                        <Form.Control {...methods.register("contactName")} />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group controlId="contactEmail">
                        <Form.Label>Contact Email</Form.Label>
                        <Form.Control
                            type="email"
                            {...methods.register("contactEmail")}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group controlId="contactNumber">
                        <Form.Label>Contact Phone</Form.Label>
                        <Form.Control {...methods.register("contactNumber")} />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group controlId="contactSite">
                        <Form.Label>Website</Form.Label>
                        <Form.Control {...methods.register("contactSite")} />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col className={classNames("d-flex", "align-items-baseline")}>
                    <Button
                        variant="primary"
                        type="submit"
                        style={{ marginRight: "1em" }}
                        disabled={sending}
                    >
                        Submit Request
                    </Button>
                    {looking && (
                        <Button
                            variant="danger"
                            type="button"
                            onClick={() => setShow(true)}
                            disabled={sending}
                        >
                            Delete Request
                        </Button>
                    )}
                    {sending === true && <Loading className="mx-3 w-auto" />}
                </Col>
            </Row>
        </Form>
    );
};

export default LFPForm;
